// otpConfig.js
export const OTP_CONFIG = {
  ADMIN_EMAIL: process.env.REACT_APP_EMAIL_ID, // Change this to your actual admin email
  WEB_APP_URL: process.env.REACT_APP_API_URL, // Your backend API endpoint
  API_KEY: process.env.REACT_APP_API_KEY, // Your API key
  OTP_LENGTH: 6,
  OTP_EXPIRY_TIME: 120, // 2 minutes in seconds
  
  STORAGE_KEYS: {
    PENDING_ACTION: 'pendingAction',
    PENDING_ITEM: 'pendingItem',
    PENDING_OTP: 'pendingOTP'
  }
};
console.log('OTP Config:', OTP_CONFIG);
// Send OTP to admin email
export const sendOTP = async (actionType, itemData) => {
  try {
    const response = await fetch(OTP_CONFIG.WEB_APP_URL, {
      method: 'POST',
      body: JSON.stringify({
        apiKey: OTP_CONFIG.API_KEY,
        origin: window.location.origin,
        action: 'sendOtp',
        email: OTP_CONFIG.ADMIN_EMAIL,
        actionType: actionType,
        itemData: itemData
      })
    });
    
    const result = await response.json();
    
    if (result.success) {
      localStorage.setItem(OTP_CONFIG.STORAGE_KEYS.PENDING_OTP, 'true');
      return { success: true, message: `OTP sent successfully to ${OTP_CONFIG.ADMIN_EMAIL}` };
    } else {
      return { success: false, message: result.error || 'Failed to send OTP' };
    }
  } catch (error) {
    console.error('Error sending OTP:', error);
    return { success: false, message: 'Failed to send OTP. Please try again.' };
  }
};

// Verify OTP
export const verifyOTP = async (otp, actionType, itemData) => {
  try {
    const response = await fetch(OTP_CONFIG.WEB_APP_URL, {
      method: 'POST',
      body: JSON.stringify({
        apiKey: OTP_CONFIG.API_KEY,
        origin: window.location.origin,
        action: 'verifyOtp',
        email: OTP_CONFIG.ADMIN_EMAIL,
        otp: otp,
        actionType: actionType,
        itemData: itemData
      })
    });
    
    const result = await response.json();
    
    if (result.success && result.data?.verified) {
      return { success: true, message: 'OTP verified successfully' };
    } else {
      return { success: false, message: result.error || 'Invalid OTP' };
    }
  } catch (error) {
    console.error('Error verifying OTP:', error);
    return { success: false, message: 'Failed to verify OTP. Please try again.' };
  }
};

// Resend OTP
export const resendOTP = async (actionType, itemData) => {
  try {
    const response = await fetch(OTP_CONFIG.WEB_APP_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        apiKey: OTP_CONFIG.API_KEY,
        origin: window.location.origin,
        action: 'sendOtp',
        email: OTP_CONFIG.ADMIN_EMAIL,
        actionType: actionType,
        itemData: itemData
      })
    });
    
    const result = await response.json();
    
    if (result.success) {
      localStorage.setItem(OTP_CONFIG.STORAGE_KEYS.PENDING_OTP, 'true');
      return { success: true, message: 'OTP resent successfully' };
    } else {
      return { success: false, message: result.error || 'Failed to resend OTP' };
    }
  } catch (error) {
    console.error('Error resending OTP:', error);
    return { success: false, message: 'Failed to resend OTP. Please try again.' };
  }
};